import React, { useState } from 'react';
import { motion } from 'framer-motion';
import InputForm from './InputForm';
import Results from './Results';
import PdfForm from './PdfForm';
import { calculateProfitability } from '../utils/calculations';

const Calculator = () => {
  const [formData, setFormData] = useState({
    // Fixed Costs
    employeeCosts: '',
    materials: '',
    subcontractors: '',
    otherFixedCosts: '',
    
    // Variable Costs
    consultantHours: '',
    hourlyRate: '',
    projectAdmin: '',
    otherVariableCosts: '',
    
    // Other Inputs
    packagePrice: '',
    contingencyBuffer: '15',
    incomeTaxRate: '30',
    
    // Referral Fee
    referralFeeType: 'amount',
    referralFeeValue: ''
  });

  const [results, setResults] = useState(null);
  const [showPdfForm, setShowPdfForm] = useState(false);

  const handleInputChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);

    // Calculate results if we have enough data
    if (updatedData.packagePrice && parseFloat(updatedData.packagePrice) > 0) {
      const calculatedResults = calculateProfitability(updatedData);
      setResults(calculatedResults);
    } else {
      setResults(null);
    }
  };

  const loadSampleData = () => {
    const sampleData = {
      employeeCosts: '2000',
      materials: '300',
      subcontractors: '1500',
      otherFixedCosts: '500',
      consultantHours: '40',
      hourlyRate: '150',
      projectAdmin: '800',
      otherVariableCosts: '400',
      packagePrice: '15000',
      contingencyBuffer: '15',
      incomeTaxRate: '30',
      referralFeeType: 'amount',
      referralFeeValue: '500'
    };
    
    setFormData(sampleData);
    const calculatedResults = calculateProfitability(sampleData);
    setResults(calculatedResults);
  };

  return (
    <motion.div 
      className="space-y-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 space-y-4 sm:space-y-0">
          <h2 className="text-xl font-semibold text-gray-900">
            Project Details
          </h2>
          <button
            onClick={loadSampleData}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 text-sm font-medium"
          >
            Load Sample Data
          </button>
        </div>
        <InputForm formData={formData} onInputChange={handleInputChange} />
      </div>

      {results && (
        <>
          <Results results={results} />
          
          <motion.div 
            className="mt-8 text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <button
              onClick={() => setShowPdfForm(true)}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors duration-200 text-base font-medium"
            >
              Get these results as a PDF
            </button>
          </motion.div>
        </>
      )}

      {showPdfForm && results && (
        <PdfForm 
          formData={formData} 
          results={results} 
          onClose={() => setShowPdfForm(false)} 
        />
      )}
    </motion.div>
  );
};

export default Calculator;